'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { ArrowIcon } from '@insta-club/components';
import { useCustomForm } from '@insta-club/hooks';
import { t } from '@insta-club/translations';
import { Button, Form } from '@insta-club/ui';
import { ResetPasswordFormValues, ResetPasswordSchema } from '@insta-club/validator';
import { useSearchParams } from 'next/navigation';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';
import PssswordInput from 'src/libs/ui/input/password';

interface Props {
    onSuccess?: () => void;
}

function ResetPasswordForm({ onSuccess }: Props) {
    const searchParams = useSearchParams();
    const username = searchParams.get('username');
    const verification_code = searchParams.get('verification_code');

    const form = useCustomForm(ResetPasswordSchema);

    const onSubmit: SubmitHandler<ResetPasswordFormValues> = async (data) => {
        let res: {
            message: boolean;
            token: string;
            status: number;
        } | null = null;

        res = await fetcher(ApiKeys.FORGET_PASSWORD, 'web', 'POST', {
            body: {
                ...data,
                username,
                verification_code
            }
        });

        if (res?.status === 422) {
            toast.error('ورودی های مورد نظر اشتباه میباشد');
            return;
        }

        toast.success('رمز عبور با موفقیت تغییر یافت');
        onSuccess?.();
    };

    return (
        <Form form={form} onSubmit={onSubmit}>
            <div className='flex flex-col gap-6'>
                <PssswordInput name='password' inputType='text' label={t('password')} />
                <PssswordInput name='password_confirmation' inputType='text' label={t('password_confirmation')} />
                <Button
                    loading={form.formState.isSubmitting}
                    type='submit'
                    size='lg'
                    fullWidth
                    icon={<ArrowIcon className='rotate-180 text-white' />}
                    iconPosition='end'
                >
                    <span className='text-base font-semibold'>{t('confirmation_new_password')}</span>
                </Button>
            </div>
        </Form>
    );
}

export default ResetPasswordForm;

